module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/112-laos-fd0d58fe2c42aa65cd1baa4aa94a3e2c.svg";